<template>
	<div class="window">
		<div v-if="$slots.title" class="title-bar">
			<slot name="title"></slot>
		</div>
		<div v-if="$slots.default" class="window-body">
			<slot></slot>
		</div>
		<div v-if="$slots.footer" class="window-footer"><slot name="footer"></slot></div>
	</div>
</template>
